<template>
  <div class="popup-wrp" v-show="value">
    <div class="popup-mask" @click="maskClick">
      <div class="popup-content" @click.stop>
        <p class="cm-title">联系客服</p>
        <p class="cm-tip">微信扫码，联系客服</p>
        <img class="cm-qrcode" :src="customerInfo.wxQrcode" alt="" />
        <p class="cm-wx-num">客服微信：{{ customerInfo.wxId }}</p>
        <p class="cm-copy-btn" @click="copyWxId">一键复制</p>
      </div>
    </div>
  </div>
</template>

<script>
import { copyText } from 'utils/tool.js'

export default {
  props: {
    value: Boolean,
    customerInfo: {
      type: Object,
      default: () => ({
        wxQrcode: '', // 客服微信二维码
        wxId: '' //客服微信号
      })
    }
  },
  methods: {
    maskClick() {
      this.$emit('input', false)
    },
    copyWxId() {
      copyText(this.customerInfo.wxId)
      this.$toast({
        text: '复制成功',
        time: 2000,
        zIndexTop: true
      })
      setTimeout(() => {
        this.$emit('input', false)
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes zoom {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
.popup-wrp {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  .popup-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    overflow: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .popup-content {
    animation: zoom 0.3s; // 添加了图片放大的效果
    width: 560px;
    height: 640px;
    background-color: #fff;
    border-radius: 30px;
    background-image: url('./xlt-custom-bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .cm-title {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #21252d;
    margin-bottom: 8px;
  }
  .cm-tip {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6c798c;
  }
  .cm-qrcode {
    width: 260px;
    height: 260px;
    background: #ffffff;
    box-shadow: 0px 2px 20px 0px rgba(153, 137, 255, 0.1);
    border-radius: 11px;
    margin: 20px 0 24px 0;
    object-fit: cover;
  }
  .cm-wx-num {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #21252d;
  }
  .cm-copy-btn {
    width: 400px;
    height: 86px;
    background: linear-gradient(180deg, #bdc9fd 0%, #5d70f9 100%);
    border-radius: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin-top: 20px;
  }
}
</style>
